import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=538a42ba&scoped=true&"
import script from "./BemVindo.vue?vue&type=script&lang=js&"
export * from "./BemVindo.vue?vue&type=script&lang=js&"
import style0 from "./BemVindo.vue?vue&type=style&index=0&id=538a42ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a42ba",
  null
  
)

export default component.exports